import { IconLock, IconShieldCheck } from "@tabler/icons-react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Button, Flex, Typography } from "antd";
import { AuthPageLayout } from "@/components/auth-layout";
import { CustomIcon } from "@/components/base";

export const Route = createFileRoute("/_public/logout")({ component: Logout });

function Logout() {
	const navigate = useNavigate();

	return (
		<AuthPageLayout>
			<Flex vertical align="center" gap={24}>
				<Flex vertical align="center" gap={6}>
					<Typography.Title
						level={3}
						style={{ margin: 0, textAlign: "center" }}
					>
						You've been signed out
					</Typography.Title>
					<Typography.Text type="secondary" style={{ textAlign: "center" }}>
						Your session has ended. See you next time.
					</Typography.Text>
				</Flex>

				{/* Goes through /login (not login() directly) so the terms checkbox
				    there stays the single gate for every sign-in. */}
				<Button
					type="primary"
					size="large"
					icon={<CustomIcon icon={IconLock} size={18} />}
					onClick={() => navigate({ to: "/login" })}
					block
					style={{ height: 48, fontSize: 15, borderRadius: 8 }}
				>
					Log in to StratoNext
				</Button>

				<Flex align="center" gap={8} style={{ marginTop: 4 }}>
					<IconShieldCheck size={16} color="#8c8c8c" />
					<Typography.Text type="secondary" style={{ fontSize: 13 }}>
						Secure access for authorized users only
					</Typography.Text>
				</Flex>
			</Flex>
		</AuthPageLayout>
	);
}
